import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  Language,
  TranslationService,
} from '../../core/i18n/translation.service';

interface LangOption {
  code: Language;
  label: string;
}

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-center gap-2" role="group" aria-label="Language selection">
      @for (lang of languages; track lang.code) {
        <button
          type="button"
          class="inline-flex items-center rounded border border-slate-600 bg-transparent px-2.5 py-0.5 text-sm font-semibold text-slate-300 transition-colors hover:border-slate-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-300 focus-visible:outline-offset-2 cursor-pointer"
          [style.background-color]="translationService.currentLang() === lang.code ? 'var(--nes-core-color-brand-yellow)' : null"
          [style.color]="translationService.currentLang() === lang.code ? 'var(--nes-core-color-brand-blue)' : null"
          [style.border-color]="translationService.currentLang() === lang.code ? 'var(--nes-core-color-brand-yellow)' : null"
          [attr.aria-pressed]="translationService.currentLang() === lang.code"
          (click)="setLang(lang.code)"
        >
          {{ lang.label }}
        </button>
      }
    </div>
  `,
})
export class LanguageSwitcherComponent {
  protected readonly translationService = inject(TranslationService);

  protected readonly languages: LangOption[] = [
    { code: 'nl', label: 'NL' },
    { code: 'en', label: 'EN' },
  ];

  setLang(lang: Language): void {
    this.translationService.setLanguage(lang);
  }
}
